import { createMuiTheme, colors } from '@material-ui/core'
import shadows from './shadows'
import typography from './typography'

const theme = createMuiTheme({
   palette: {
      background: {
         default: '#fff',
         paper: '#f0f0f0' || colors.common.white
      },
      primary: {
         contrastText: '#fff',
         main: '#D22F25'
      },
      text: {
         primary: '#8d8d8d',
         secondary: 'grey'
      }
   },
   shadows,
   typography
})

export default theme
